// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BehanceOutlinedSvg from "@ant-design/icons-svg/es/asn/BehanceOutlined";
import AntdIcon from '../components/AntdIcon';

var BehanceOutlined = function BehanceOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BehanceOutlinedSvg
  }));
};

BehanceOutlined.displayName = 'BehanceOutlined';
export default React.forwardRef(BehanceOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BehanceOutlined.js
// module id = 631
// module chunks = 0